import VueSocialSharing from 'vue-social-sharing'

export default (app) => {
  app.use(VueSocialSharing)
}
